import * as React from 'react';
import classnames from 'classnames';
import { ChechoutRedeemVoucher } from 'src/js/model/checkout/RedeemVoucher';
import { PurchaseItem } from 'src/js/model/index';
import AmountComp from '../../../components/AmountComp';
import ContactComp, {Props as ContactProps} from './ContactComp';
import {
  Amount,
  RedeemVoucher,
  Promotion,
  ConcessionType,
  Voucher,
  Article
,StudentMembership,Concession} from '@api';
import {scrollToTop} from 'src/js/common/utils/DomUtils';
import {SummaryListComp} from '../../result/components/SummaryListComp';

export interface Props {
  hasSelected: boolean;
  contacts: ContactProps[];
  amount: Amount;
  onAddContact?: () => void;
  onAddParent?: () => void;
  onRemoveContact?: () => void;
  onChangeParent?: (contactId: string) => void;
  onAddCode: (code: string) => void;
  promotions: Promotion[];
  redeemVouchers?: RedeemVoucher[];
  redeemedVoucherProducts?: ChechoutRedeemVoucher[];
  onToggleVoucher?: (redeemVoucher: RedeemVoucher, enabled) => void;
  onToggleVoucherProduct?: (redeemVoucher: ChechoutRedeemVoucher, enabled) => void;
  onProceedToPayment?: (forms) => void;
  onProceedToJoin?: (forms) => void;
  onSelect?: (item: PurchaseItem, selected: boolean) => void;
  onChangeClass?: (item1: PurchaseItem, item2: PurchaseItem) => void;
  onPriceValueChange?: (productItem: Voucher, val: number) => void;
  onQuantityValueChange?: (productItem: Voucher|Article, val: number) => void;
  onUpdateWaitingCourse?: () => void;
  onAddConcession?: () => void;
  onInit?: () => void;
  concessions?: Concession[];
  concessionTypes?: ConcessionType[];
  memberships?: StudentMembership[];
  onUpdatePayNow?: (val, validate?: boolean) => void;
  needParent?: boolean;
  fetching?: boolean;
  onChangeCustomFields?: (form, type) => any;
  forms?: any;
  isOnlyWaitingLists?: boolean;
}

export class SummaryComp extends React.Component<Props, any> {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      isAutoSubmitting: false,
      previewMode: urlParams.get('previewMode')
    }
  }

  componentDidMount() {
    const { onInit } = this.props;

    scrollToTop();

    if (onInit) {
      onInit();
    }
  }

  componentDidUpdate() {
    const { contacts, isOnlyWaitingLists, forms, onProceedToJoin } = this.props;
    const { isAutoSubmitting } = this.state;

    if (!isAutoSubmitting && contacts.length && isOnlyWaitingLists) {
      const hasNoFormFieldsOrErrors = !contacts.some(c => c.waitingLists.some(wl =>
        wl.waitingList.fieldHeadings.length || wl.waitingList.errors.length)
      )

      if(hasNoFormFieldsOrErrors) {
        this.setState({
          isAutoSubmitting: true
        })
        onProceedToJoin(forms)
      }
    }
  }

  renderContact = (props: ContactProps) => {
    const {onSelect, onPriceValueChange, onQuantityValueChange, onAddConcession, concessions, memberships, onChangeParent,
      onUpdateWaitingCourse, onChangeCustomFields, concessionTypes, onRemoveContact, onChangeClass} = this.props;

    return (
      <ContactComp
        {...props}
        key={props.contact.id}
        onChangeClass={onChangeClass}
        onSelect={(item, selected) => onSelect(item, selected)}
        onPriceValueChange={(productItem, val) => onPriceValueChange(productItem, val)}
        onQuantityValueChange={(productItem, val) => onQuantityValueChange(productItem, val)}
        onChangeParent={onChangeParent}
        onAddConcession={onAddConcession}
        concessions={concessions.filter(item => item.contactId === props.contact.id)}
        concessionTypes={concessionTypes}
        studentMemberships={memberships.filter(item => item.contactId === props.contact.id)}
        onUpdateWaitingCourse={onUpdateWaitingCourse}
        onChangeCustomFields={onChangeCustomFields}
        onRemoveContact={onRemoveContact}
      />
    );
  }

  render() {
    const {
      contacts, amount, onAddContact, onAddCode, onProceedToPayment, fetching, onAddParent, forms, onProceedToJoin,
      redeemVouchers, hasSelected, promotions, onUpdatePayNow, onToggleVoucher, needParent, isOnlyWaitingLists,
      redeemedVoucherProducts, onToggleVoucherProduct
    } = this.props;

    const { previewMode } = this.state;

    const buttonLabel = needParent && !isOnlyWaitingLists ? 'Add Guardian' :
      !Number(amount.total) ? 'Proceed' : 'Proceed to Payment';

    const onProceed = needParent && !isOnlyWaitingLists ? () => onAddParent() :
      isOnlyWaitingLists ? () => onProceedToJoin(forms) : () => onProceedToPayment(forms);

    const haveTotal = !!(amount && Number(amount.total));

    const relatedClassError = contacts.some(contact =>
      contact.enrolments.some(enr => !enr.enrolment.classId && enr.enrolment.allowRemove === false));

    return previewMode ? <SummaryListComp
      contacts={contacts}
      corporatePass={null}
    /> : (
      <div className="payment-summary">
        <div className={classnames('contacts-summary', {fetching})}>
          {contacts.map(c => c.contact && this.renderContact(c))}
        </div>
        <AddAnotherContact onAddContact={onAddContact}/>

        <div className="row">
          <div className="col-24 col-xs-24">
            {hasSelected &&
              <div className={classnames('row amount-container', {'zero-total': !haveTotal})}>
                {haveTotal &&
                  <AmountComp
                    amount={amount}
                    onUpdatePayNow={amount.isEditable ? onUpdatePayNow : undefined}
                    onAddCode={onAddCode}
                    onToggleVoucher={onToggleVoucher}
                    onToggleVoucherProduct={onToggleVoucherProduct}
                    redeemVouchers={redeemVouchers}
                    redeemedVoucherProducts={redeemedVoucherProducts}
                    promotions={promotions}
                  />
                }
                <div className="col-24 col-xs-24 checkout-btn-proceed text-right">
                  <ProceedToPayment
                    buttonLabel={buttonLabel}
                    disabled={!hasSelected || relatedClassError}
                    onProceedToPayment={onProceed}
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const ProceedToPayment = props => {
  const {disabled, onProceedToPayment, buttonLabel} = props;
  const className = classnames('btn', 'btn-primary', {disabled});

  const onClick = e => {
    e.preventDefault();
    onProceedToPayment();
  };

  return (!disabled &&
    <button className={className} onClick={onClick} disabled={disabled}>
      {buttonLabel}
    </button>
  );
};

const AddAnotherContact = props => {
  const {onAddContact} = props;

  const onClick = e => {
    e.preventDefault();
    onAddContact();
  };

  return (
    <div className="row" id="totals">
      <div className="col-24 col-xs-24">
        <a className="new-student-link" id="addContact" href="#addContact" onClick={onClick}>Add another student</a>
      </div>
    </div>
  );
};
